import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function LoginPage({ onLogin }) {
  const [tab, setTab]           = useState('login');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp]           = useState('');
  const [newPass, setNewPass]   = useState('');
  const [step, setStep]         = useState(1);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [msg, setMsg]           = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      onLogin(data.token);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally { setLoading(false); }
  }

  async function handleForgot(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/admin/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setMsg('Check your email for a 6-digit code');
      setStep(2);
    } catch (err) {
      setError(err.message || 'Failed to send code');
    } finally { setLoading(false); }
  }

  async function handleReset(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${API}/admin/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp, newPassword: newPass })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setMsg('Password reset! Please log in.');
      setTab('login'); setStep(1); setOtp(''); setNewPass('');
    } catch (err) {
      setError(err.message || 'Failed to reset password');
    } finally { setLoading(false); }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logoWrap}>
          <img src="/tbold-logo-admin-05.svg" alt="Thunderbolt" style={{height:48, objectFit:'contain'}}/>
        </div>
        <div style={s.title}>Thunderbolt Admin</div>

        {/* Tabs */}
        <div style={s.tabRow}>
          <button style={{...s.tab, ...(tab==='login' ? s.tabActive : {})}}
            onClick={() => { setTab('login'); setStep(1); setError(''); setMsg(''); }}>
            Log in
          </button>
          <button style={{...s.tab, ...(tab==='forgot' ? s.tabActive : {})}}
            onClick={() => { setTab('forgot'); setStep(1); setError(''); setMsg(''); }}>
            Forgot password
          </button>
        </div>

        {error && <div style={s.error}>{error}</div>}
        {msg   && <div style={s.success}>{msg}</div>}

        {/* Login form */}
        {tab === 'login' && (
          <form onSubmit={handleLogin}>
            <div style={s.field}>
              <label style={s.label}>Email</label>
              <input style={s.input} type="email" placeholder="admin@thunderboltapps.com"
                value={email} onChange={e => setEmail(e.target.value)} required/>
            </div>
            <div style={s.field}>
              <label style={s.label}>Password</label>
              <input style={s.input} type="password" placeholder="••••••••"
                value={password} onChange={e => setPassword(e.target.value)} required/>
            </div>
            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Log in'}
            </button>
          </form>
        )}

        {/* Forgot password — step 1: enter email */}
        {tab === 'forgot' && step === 1 && (
          <form onSubmit={handleForgot}>
            <div style={s.field}>
              <label style={s.label}>Email address</label>
              <input style={s.input} type="email" placeholder="admin@thunderboltapps.com"
                value={email} onChange={e => setEmail(e.target.value)} required/>
            </div>
            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send reset code'}
            </button>
          </form>
        )}

        {/* Forgot password — step 2: enter OTP + new password */}
        {tab === 'forgot' && step === 2 && (
          <form onSubmit={handleReset}>
            <div style={s.field}>
              <label style={s.label}>6-digit code</label>
              <input style={{...s.input, fontSize:24, letterSpacing:8, textAlign:'center'}}
                type="text" placeholder="000000" maxLength={6}
                value={otp} onChange={e => setOtp(e.target.value)} required/>
            </div>
            <div style={s.field}>
              <label style={s.label}>New password</label>
              <input style={s.input} type="password" placeholder="At least 8 characters"
                value={newPass} onChange={e => setNewPass(e.target.value)} required/>
            </div>
            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset password'}
            </button>
            <button style={s.backBtn} type="button" onClick={() => setStep(1)}>
              ← Back
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const s = {
  page:    {minHeight:'100vh', background:'#F5F5F7', display:'flex', alignItems:'center', justifyContent:'center', padding:24},
  card:    {background:'#fff', borderRadius:24, padding:32, width:'100%', maxWidth:400, boxShadow:'0 4px 40px rgba(0,0,0,0.1)'},
  logoWrap:{display:'flex', justifyContent:'center', marginBottom:12},
  title:   {fontSize:20, fontWeight:700, color:'#1D1D1F', textAlign:'center', marginBottom:24},
  tabRow:  {display:'flex', background:'#F5F5F7', borderRadius:10, padding:3, gap:3, marginBottom:24},
  tab:     {flex:1, padding:'9px 0', textAlign:'center', fontSize:13, fontWeight:500, border:'none', borderRadius:8, background:'transparent', color:'#6E6E73', cursor:'pointer'},
  tabActive:{background:'#fff', color:'#1D1D1F', boxShadow:'0 1px 4px rgba(0,0,0,0.1)'},
  field:   {marginBottom:16},
  label:   {display:'block', fontSize:13, fontWeight:500, color:'#1D1D1F', marginBottom:6},
  input:   {width:'100%', padding:'13px 14px', border:'1.5px solid #F0F0F0', borderRadius:12, fontSize:15, background:'#FAFAFA', color:'#1D1D1F', outline:'none', boxSizing:'border-box'},
  btn:     {width:'100%', padding:14, background:'#007AFF', color:'#fff', border:'none', borderRadius:12, fontSize:15, fontWeight:600, cursor:'pointer', marginBottom:8},
  backBtn: {width:'100%', padding:12, background:'transparent', color:'#6E6E73', border:'none', fontSize:13, cursor:'pointer'},
  error:   {background:'#FFF0EF', border:'1px solid #FFD0CE', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#FF3B30', marginBottom:16},
  success: {background:'#E6FAF5', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#00C48C', marginBottom:16},
};
